import { JsonObject, JsonProperty } from 'json2typescript';
import Thumbnail from '@/models/exam/Thumbnail';

@JsonObject('benefits_detail')
export default class BenefitsDetail {
  constructor() {
    this.order = undefined;
    this.isShareTarget = undefined;
    this.isNotShowDownload = undefined;
    this.isPositionResultTop = undefined;
    this.benefitsResource = undefined;
    this.buttonText = undefined;
  }

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('is_share_target')
  public isShareTarget?: boolean;

  @JsonProperty('is_not_show_download')
  public isNotShowDownload?: boolean;

  @JsonProperty('is_position_result_top')
  public isPositionResultTop?: boolean;

  @JsonProperty('benefits_resource', Thumbnail, true)
  public benefitsResource?: Thumbnail;

  @JsonProperty('button_text')
  public buttonText?: string;
}
